export default function cepMask(text) {
  const textClean = text.replace(/\D/g, '');
  const textPhone = textClean.replace(/(\d)(\d{3})$/, '$1-$2');
  return textPhone;
}
